import React, { Component } from 'react';
// 3rd Party
import { Grid, Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import v4 from 'uuid';
import scrollToComponent from 'react-scroll-to-component';
// Components
import BulletEntry from './presentationComponents/BulletEntry';
import IconBlock from './presentationComponents/IconBlock';
import Aaron_McCloud_Resume from './Aaron_McCloud_Resume.pdf'
// Styles
import './App.css';

class App extends Component {
  state = {};

  // componentDidMount() {
  //   fetch('http://url.com/endpoint')
  //     .then(
  //       data => this.setState({ data }),
  //       err => console.log(err)
  //     );
  // }

  scrollTo(sectionStr) {
    scrollToComponent(
      this[sectionStr],
      {
        offset: 0,
        align: 'top',
        duration: 2000
      }
    );
  }

  render() {
    const bulletsAndDropdowns = [
      {
        title: 'Experience Delivering Results At Amazon, Disney, & Microsoft',
        content: [
          'At Disney in 2019 & 2020 I spearheaded the One-ID sign-on upgrade to React.js, and led a team of engineers to develop the One-ID mobile platform integration.',
          'At Amazon I used Angular.js to build out the front-end of their Machine Learning platform on Amazon Web Services. In 2016 at Microsoft I built out the Retail Demo Experience, a carousel demo app which shipped with Windows 10. Immediately after release it ran on hardware in all Microsoft stores worldwide.',
          'This gave me the ability to jump into new projects and get up-to-speed quickly, and experience delivering scalable software globally.'
        ]
      },
      {
        title: 'Ability to Deliver on Tight Deadlines',
        content: [
          'At Disney I delivered comprehensive feature-work & test coverage for the One-ID sign-on service, as well as leading a team of developers that solved the mobile integration with One-ID.',
          'At RealSelf I delivered on their email template migration in just 4 weeks, and at CoralDocs I architected a full-stack web application (AWS backend, React.js front-end), and built the entire React.js front-end in 6 weeks.'
        ]
      },
      {
        title: 'Software Leadership & Full-Stack Knowledge',
        content: [
          'I\'ve led multiple teams, at startups (CoralDocs) and larger companies (Disney & Qualtrics), to deliver quality, scalable software. I understand the leadership aspects of emotionally focusing a team, as well as the management needed for task organization, coordinating deliverables, and keeping team members accountable.',
          'My professional software career has incorporated full-stack development, from AWS & Google Cloud on the backend to JavaScript frameworks and Vanilla JS on the front-end. I can, and will, hit work out of the park!'
        ]
      }
    ];
    const iconsArr = [
      {
        classNmStr: 'code',
        description: ['Expert developer']
      },
      {
        classNmStr: 'fighter-jet',
        description: ['Takes initiative']
      },
      {
        classNmStr: 'line-chart',
        description: ['Sees the big picture & delivers results!']
      }
    ];
    const bulletPoints = [
      'Write excellent front-end code,',
      'Understands modern, scalable software architecture,',
      '...and can lead a team, as well as follow directions.'
    ];
    const conclusion = [
      'You want a professional engineer who can deliver front-end results and lead.',
      'I want to work at a company with a positive global impact, and a passion for the customer experience.',
      'Let\'s see if we\'re a good fit.'
    ];

    return (
      <div className="App">
        <div className="title-container">
          <h1 className="App-title">
            Why Amazon<br />Might Want Aaron... 😉
          </h1>
        </div>
        <header className="App-header first">
          <FontAwesome
            name='chevron-down'
            size='5x'
            onClick={() => this.scrollTo('BulletEntrySec')}
          />
        </header>
        <Grid
          className="grid-container"
          ref={(sec) => { this.BulletEntrySec = sec; }}>
          {
            bulletsAndDropdowns
            .map((entry) => (
              <BulletEntry
                key={v4()}
                title={entry.title}
                contentArr={entry.content}
              />
            ))
          }
          <Row className="icon-row">
            {
              iconsArr
              .map((obj)=>(
                <IconBlock
                  key={v4()}
                  classNmStr={obj.classNmStr}
                  description={obj.description} />
              ))
            }
          </Row>
          <Row className="splash-block bottom-block">
            <Col xs={12} xsOffset={0} md={10} mdOffset={1}>
              <h2>
                Leadership &amp; Software Results
              </h2>
              <p className="lead">You want an engineer who knows the front-end, with coding and leadership skills. And someone who's not afraid of learning new technologies on the fly.</p>
              <p className="lead">Someone who can...</p>
              <ul>
                {
                  bulletPoints
                  .map((reasonStr) => (
                    <li key={v4()} className="lead">
                      {reasonStr}
                    </li>
                  ))
                }
              </ul>
              <p className="lead">I can do all of the above, and with style &mdash; to show off for engineers &amp; customers alike.</p>
            </Col>
          </Row>
          <Row className="final-block bottom-block">
            <Col xs={12} xsOffset={0} md={10} mdOffset={1}>
              <h2>Code Artistry</h2>
              {
                conclusion
                .map((sentence) => (
                  <p key={v4()} className="lead">
                    {sentence}
                  </p>
                ))
              }
              <div className="anchor-align">
                <a className="lead" href="mailto:aaron@aaroncodes.com">
                  aaron@aaroncodes.com
                </a>
                <a className="lead" href="tel:206-949-9806">
                  (206) 949-9806
                </a>
                <a className="lead" href={Aaron_McCloud_Resume} download>
                  Aaron McCloud's Resume
                </a>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js